<template>
  <v-select
    dense
    :label="outlineSelect ? 'בחר מדינה' : ''"
    :outlined="outlineSelect"
    :items="countriesList"
    item-text="name"
    :append-icon="disabled ? '' : '$dropdown'"
    return-object
    v-model="dataValue"
    :class="outlineSelect ? '' : 'no-shadow'"
    solo
    :hide-details="true"
    :disabled="disabled"
    :placeholder="disabled ? value : ''"
  >
    <template #item="{ item }">
      <country-flag class="pr-1" v-if="dataValue" :country='item.code.toLowerCase()' size='big'/>
      <p class="secondary--text font-weight-medium">
        <span>
          {{ item.name }}
        </span>
      </p>
    </template>
    <template #selection="{}">
  
      <country-flag class="pr-1" v-if="dataValue" :country='dataValue.code.toLowerCase()' size='big'/>
    </template>
  </v-select>
</template>

<script >
import axios from "axios";
import find from "lodash/find";
import padStart from "lodash/padStart";
import isNil from "lodash/isNil";
import isEmpty from "lodash/isEmpty";
import selectMixin from "@/mixins/selectMixin.js";

export default {
  name: "CountrySelect",
  mixins: [selectMixin],
  props: {
    outlineSelect: {
      type: Boolean,
      required: false,
      default: true,
    },
    newSelection: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data() {
    return {
      countriesList: null,
      defaultCountry: {
        name: "Israel",
        code: "IL",
        dial_code: "+972",
        flag: "🇮🇱",
      },
    };
  },
  created() {
    this.fetchCountries();
  },
  watch: {
    value: {
      immediate: true,
      handler: function (newValue) {
        if (newValue) {
          this.dataValue = newValue;
        }
      },
    },
  },
  computed: {
    dataValue: {
      get() {
        if (this.value && typeof this.value === "string") {
          let paddingLength = 4;
          if (this.value.length < 3) paddingLength = 3;
          if (this.value.length < 2) paddingLength = 2;
          return find(this.countriesList, [
            "dial_code",
            padStart(this.value, paddingLength, "+"),
          ]);
        } else if (isNil(this.value)) {
          this.$emit("selectCountry", this.defaultCountry);
          return this.defaultCountry;
        } else {
          return this.value;
        }
      },
      set(val) {
        // console.log('set country : ', val);
        if (typeof val === "string" && val.length > 0) {
          this.$emit("selectCountry", val);
        }
        if (typeof val !== "string" && !isEmpty(val)) {
          if (this.newSelection) this.$emit("selectCountry", val);
          else this.$emit("changeCountry", val);
        }
      },
    },
  },
  methods: {
    async fetchCountries() {
      const { data } = await axios.get("/countriesWithFlags.json");
      this.countriesList = data;
    },
  },
};
</script>

<style lang="sass">
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot
  box-shadow: none
.theme--light.v-icon
  color: rgba(0, 0, 0, 1)
.v-input__icon.v-input__icon--append
  padding-bottom: 16px
.v-input__append-inner > div > i
  margin-right: 16px !important
.v-icon.v-icon::after
  height: 80% !important
.v-input__control
  height: 70% !important
</style>
